import Modal from 'components/modal'
import { formatDate } from 'utils/helpers'
import { formatExecutionTime, GenericLogStatusBadge } from './utils'

type Props = {
  log: any | null
  isOpen: boolean
  onClose: () => void
}

const Row = ({ label, value }: { label: string; value: React.ReactNode }) => (
  <div className="flex gap-3 text-sm">
    <span className="w-36 shrink-0 font-semibold text-gray-600">{label}</span>
    <span className="break-all text-gray-800">{value ?? '-'}</span>
  </div>
)

/**
 * Shows one generic log entry. `metadata` differs per action (stores, counts,
 * per-store results, ...), so it is rendered as formatted JSON.
 */
const GenericLogDetailsModal = ({ log, isOpen, onClose }: Props) => (
  <Modal
    width={760}
    title="Log Details"
    titleClassname="text-xl font-semibold"
    isOpen={isOpen}
    closeModal={onClose}
    customStyle={{ padding: '30px 40px', height: 'auto', maxHeight: '85vh' }}
  >
    <div className="mt-5 space-y-2 overflow-y-auto">
      <Row label="Module" value={log?.module} />
      <Row label="Service" value={log?.service} />
      <Row label="Action" value={log?.action} />
      <Row
        label="Status"
        value={<GenericLogStatusBadge status={log?.status} />}
      />
      <Row label="Requested By" value={log?.requestedBy?.name} />
      <Row
        label="Execution Time"
        value={formatExecutionTime(log?.executionTimeMs)}
      />
      <Row
        label="Created At"
        value={
          log?.createdAt
            ? formatDate(log.createdAt, { includeTime: true })
            : '-'
        }
      />
      {log?.error?.message && (
        <Row
          label="Error"
          value={<span className="text-red-600">{log.error.message}</span>}
        />
      )}

      <p className="pt-3 text-sm font-semibold text-gray-600">Details</p>
      <pre className="max-h-[45vh] overflow-auto rounded-lg bg-gray-50 p-4 text-xs text-gray-800">
        {JSON.stringify(log?.metadata ?? {}, null, 2)}
      </pre>
    </div>
  </Modal>
)

export default GenericLogDetailsModal
